import { render, staticRenderFns } from "./payment-type-satispay.vue?vue&type=template&id=6b8d5d56"
import script from "./payment-type-satispay.vue?vue&type=script&lang=js"
export * from "./payment-type-satispay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports